function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Layout from '@4c/layout';
import React from 'react';

function ModalButtonGroup({
  children,
  ...props
}) {
  return React.createElement(Layout, _extends({
    reverse: true,
    justify: "space-between"
  }, props), children);
}
/** @component */


export default ModalButtonGroup;